import {
  inject,
  observer,
} from 'mobx-react';
import {
  WithSnackbarProps,
} from 'notistack';
import React, {
  Component,
} from 'react';
import AlertDialog from '../../components/Dialog/alertDialog';
import GeneralTableComponent from '../../components/GeneralCRUDComponent/GeneralTableComponent/GeneralTableComponent';
import {
  TableCellTypes,
} from '../../components/GeneralCRUDComponent/TableCellTypes/TableCellTypes';
import {
  translate,
} from '../../helperFunctions/translation';
import {
  CountryStore,
} from '../../mobx-store/stores/countryStore';
import {
  IFacilitiesAreasStore,
} from '../../mobx-store/storeInterfaces/facilityAreaInterface';

interface IProps extends WithSnackbarProps {
  facilityAreaStore: IFacilitiesAreasStore;
  countryStore: CountryStore;
  history: any;
}

interface IState {
  open: boolean;
}

@inject('facilityAreaStore')
@inject('countryStore')
@observer
class FacilitiesArea extends Component<IProps, IState> {
  addButton: any;

  tableHeader: any = [];

  tableData: any[] = [];

  tableCellTypes: TableCellTypes[] = [];

  title: string;

  handleAgree: () => void = () => null;

  constructor(props: IProps) {
    super(props);
    this.title = translate('facilitiesAreasListPageTitle', {
    });
    this.state = {
      open: false,
    };
  }

  handleTableButtonCellClicked = (index: number, key: string) => {
    this.props.history.push(`/facilities-areas/${this.props.facilityAreaStore.facilitiesAreas[index].facilityAreaId}/edit`);
  };

  handleClickOpen = () => {
    this.setState({
      open: true,
    });
  };

  handleAdd = (): void => {
    this.props.history.push('/facilities-areas/new');
  };

  handleClose = () => {
    this.setState({
      open: false,
    });
  };

  getAddFacilityAreaButton = () => ({
    title: translate('facilitiesAreasListAddButton', {
    }),
    onAdd: this.handleAdd,
  });

  getFacilitiesAreasTableHeader = () => [
    {
      title: translate('facilitiesAreasListTitleColumnTitle', {
      }),
    },
    {
      title: translate('facilitiesAreasListEditColumnTitle', {
      }),
    },
  ];

  getFacilitiesAreasTableData = () => this.props.facilityAreaStore.facilitiesAreas
    .map((area) => ({
      ...area,
      edit: 'Edit',
    }));

  getFacilityAreasTableCellTypes = (): TableCellTypes[] => [
    {
      cellType: 'Text',
      key: 'title',
    },
    {
      cellType: 'Button',
      key: 'edit',
      onClick: this.handleTableButtonCellClicked,
    },
  ];

  returnTableData = () => {
    this.addButton = this.getAddFacilityAreaButton();
    this.tableHeader = this.getFacilitiesAreasTableHeader();
    this.tableData = this.getFacilitiesAreasTableData();
    this.tableCellTypes = this.getFacilityAreasTableCellTypes();
  };

  render() {
    this.returnTableData();
    return (
      <GeneralTableComponent
        emptyMessage={translate('facilitiesAreasListNoCategoriesMessage', {
        })}
        title={this.title}
        tableHeader={this.tableHeader}
        tableData={this.tableData}
        tableCellTypes={this.tableCellTypes}
        addButton={this.addButton}
        loadingStatus={[
          this.props.facilityAreaStore.getFacilitiesAreasRequestStatus,
          this.props.countryStore.getManagedCountriesRequestStatus
        ]}
      />
    );
  }

  async componentDidMount() {
    const {
      countryStore,
      facilityAreaStore,
    } = this.props;
    await countryStore.getUserManagedCountries();
    facilityAreaStore.getFacilityAreas(countryStore.managedCountries);
  }
}

export default FacilitiesArea;
